import { GetAllGGNotificationGraspDTO, GetAllGGNotificationGraspFiltersDTO, GGNotificationGraspDTO } from "./dto";
import { GGNotificationGraspServiceImpl } from "./serviceImpl";

export interface GGNotificationGraspService {
    UpdateGGNotificationGrasp(data: GGNotificationGraspDTO, id: string): Promise<void>
    GetAllGGNotificationGrasp(filters: GetAllGGNotificationGraspFiltersDTO): Promise<GetAllGGNotificationGraspDTO>
    GetGGNotificationGraspById(id: string): Promise<GGNotificationGraspDTO>
}

export function NewGGNotificationGraspService(): GGNotificationGraspService {
    return new GGNotificationGraspServiceImpl()
}